import { createSelector } from '@reduxjs/toolkit';
import { getTermsValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectLandStatus = createSelector(selectJsonQuery, jsonQuery => getTermsValue('land_status')(jsonQuery));
